'use strict';

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var SvgIcon = require('@mui/material/SvgIcon');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var SvgIcon__default = /*#__PURE__*/_interopDefaultLegacy(SvgIcon);

var Processor = function Processor(props) {
  return /*#__PURE__*/React__default["default"].createElement(SvgIcon__default["default"], _rollupPluginBabelHelpers["extends"]({
    viewBox: "0 0 270 250"
  }, props), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M143.8 87.3h22.5c2.4 0 4.4 2 4.4 4.4v22.5c0 2.4-2 4.4-4.4 4.4h-22.5c-2.4 0-4.4-2-4.4-4.4V91.7c0-2.4 2-4.4 4.4-4.4m0 41.1h22.5c2.4 0 4.4 2 4.4 4.4v22.5c0 2.4-2 4.4-4.4 4.4h-22.5c-2.4 0-4.4-2-4.4-4.4v-22.5c0-2.4 2-4.4 4.4-4.4zm-39.9 0h22.5c2.4 0 4.4 2 4.4 4.4v22.5c0 2.4-2 4.4-4.4 4.4h-22.5c-2.4 0-4.4-2-4.4-4.4v-22.5c0-2.4 1.9-4.4 4.4-4.4zm0-41.1h22.5c2.4 0 4.4 2 4.4 4.4v22.5c0 2.4-2 4.4-4.4 4.4h-22.5c-2.4 0-4.4-2-4.4-4.4V91.7c0-2.4 1.9-4.4 4.4-4.4z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M138.6 233.4H64.4c-19.1 0-34.7-15.6-34.7-34.7v-64c0-3.2 2.6-5.8 5.8-5.8 3.2 0 5.8 2.6 5.8 5.8v64c0 12.7 10.3 23.1 23.1 23.1h74.2c3.2 0 5.8 2.6 5.8 5.8 0 3.2-2.6 5.8-5.8 5.8zM234.5 121.1c-3.2 0-5.8-2.6-5.8-5.8v-64c0-12.7-10.3-23.1-23.1-23.1h-74.2c-3.2 0-5.8-2.6-5.8-5.8s2.6-5.8 5.8-5.8h74.2c19.1 0 34.7 15.6 34.7 34.7v64c0 3.2-2.6 5.8-5.8 5.8z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M55.6 150.4c-1.5 0-3-.6-4.2-1.8l-16.5-17-16.5 17c-2.2 2.3-5.9 2.3-8.2.1-2.3-2.2-2.4-5.9-.1-8.2l20.7-21.2c.6-.6 1.2-1 1.9-1.3.7-.3 1.5-.4 2.2-.4.8 0 1.5.1 2.2.4.7.3 1.4.7 1.9 1.3l20.7 21.2c2.2 2.3 2.2 6-.1 8.2-1 1.1-2.5 1.7-4 1.7zM235.1 132.5c-.1 0-.1 0 0 0-.9 0-1.7-.2-2.5-.6-.6-.3-1.2-.7-1.7-1.2l-.1-.1-20.7-21.2c-2.2-2.3-2.2-6 .1-8.2 2.3-2.2 6-2.2 8.2.1l16.5 17 16.5-17c2.2-2.3 5.9-2.3 8.2-.1 2.3 2.2 2.4 5.9.1 8.2L239 130.6l-.1.1c-.5.5-1 .8-1.6 1.1-.5.5-1.3.7-2.2.7z"
  }));
};
Processor.propTypes = SvgIcon__default["default"].propTypes;

module.exports = Processor;
